import type { Radio } from '@sats-group/ui-lib/react/radio/radio.types';
import type { ValueOf } from 'type-fest';

export const themes = {
  horizontal: 'horizontal',
} as const;

export type RadioList = {
  defaultCheckedValue?: string;
  label: string;
  options: Radio[];
  showOnlyOneCustomError?: boolean;
  theme?: ValueOf<typeof themes>;
};
